import styled from "styled-components";

export const ContainerForm = styled.div`
  padding: 20px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.neutral.neutral05};
`;

export const ContainerTexto = styled.div`
  padding: 24px 0;
`;

export const UploadContainer = styled.div`
  display: grid;
  gap: 0.35rem;

  span {
    font-size: 14px;
  }
`;

export const ContainerFechar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
`;